import { Pipe, PipeTransform } from '@angular/core';
import { GravatarService } from 'app/core/gravatar.service';

@Pipe({
  name: 'gravatarUrl',
  standalone: false,
})
export class GravatarUrlPipe implements PipeTransform {
  constructor(private readonly gravatarService: GravatarService) {}

  transform(gravatarHash: string): string {
    let url = '';
    if (gravatarHash) {
      url = this.gravatarService.getFullUrl(gravatarHash);
    }
    return url;
  }
}
